module.exports = __webpack_public_path__ + "img/audio-b.221086da.png";